import { defineComponent as _defineComponent } from 'vue'
import { computed, reactive, ref, watch } from 'vue';
import { AuthorityType, Permission } from 'ah-api-gateways';
import { FormDefinition, FormValidation } from 'ah-common-lib/src/form/interfaces';
import { makeFormModel } from 'ah-common-lib/src/form/helpers/formMaker';
import { checkboxField } from 'ah-common-lib/src/form/models';
import { helpers } from '@vuelidate/validators';
import { useTheme } from 'ah-theme';


export default /*#__PURE__*/_defineComponent({
  __name: 'OBOSettingsForm',
  props: {
    permissions: null,
    validation: null
  },
  emits: ["update:permissions", "update:validation"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:permissions', value: Permission[]): void;
  (e: 'update:validation', value: FormValidation<Permission[]>): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { permissions?: Permission[]; validation?: FormValidation<Permission[]> };





const getAgreementLink = 'https://www.assurehedge.com/wp-content/uploads/Assure_Hedge_UK_LTD_LPOA_Draft_02092021.pdf';

const permissions = ref({
  title: 'OBO Permissions',
  description: `OBO (On Behalf Of) permits ${useTheme().val.name} to
    trade and make payments on your behalf. These settings can be changed
    after your account is activated.`,
  options: [
    { key: AuthorityType.TRADE_ON_BEHALF_OF, value: false, label: 'Trading OBO' },
    { key: AuthorityType.PAY_ON_BEHALF_OF, value: false, label: 'Payment OBO' },
  ],
});

const calculatedModel = computed(() =>
  permissions.value.options.map((opt) => ({ authority: opt.key, allow: opt.value } as Permission))
);

const validation = computed(() => {
  return {
    $model: calculatedModel.value,
    $invalid: !!agreementFM.validation?.$invalid,
    $dirty: !!agreementFM.validation?.$dirty,
  } as FormValidation<Permission[]>;
});

const anyPermissionSet = computed(() => permissions.value.options.findIndex((p) => p.value) >= 0);

const agreementFM = reactive<FormDefinition>({
  form: makeFormModel({
    name: 'agreementConfirm',
    fieldType: 'form',
    fields: [
      checkboxField(
        'lpoaAgreed',
        '',
        false,
        {
          hidden: () => !anyPermissionSet.value,
          errorMessages: { mustAccept: 'Required field' },
        },
        {
          mustAccept: helpers.withParams(
            { type: 'mustAccept' },
            (val: any) => !anyPermissionSet.value || (anyPermissionSet.value && !!val)
          ),
        }
      ),
    ],
  }),
  validation: null,
});

watch(
  () => props.permissions,
  () => {
    const tradeChecked =
      props.permissions?.find((p) => p.authority === AuthorityType.TRADE_ON_BEHALF_OF && p.allow)?.allow ?? false;
    const paymentChecked =
      props.permissions?.find((p) => p.authority === AuthorityType.PAY_ON_BEHALF_OF && p.allow)?.allow ?? false;

    if (tradeChecked || paymentChecked) {
      permissions.value.options[0].value = tradeChecked;
      permissions.value.options[1].value = paymentChecked;
    }
  },
  { immediate: true }
);

watch(calculatedModel, () => emit('update:permissions', calculatedModel.value));

watch(validation, () => emit('update:validation', validation.value));

return { __sfc: true,props, emit, getAgreementLink, permissions, calculatedModel, validation, anyPermissionSet, agreementFM }
}

})